import ExaminationInstruction from './ExaminationInstruction';

export default ExaminationInstruction;
